import React from 'react';
import { Translate } from 'react-redux-i18n';
import get from 'lodash.get';
import { ViewTable } from '../layouts/viewTable';
import { ViewSectionRow } from '../layouts/viewSectionRow';

interface Props { entity: any; isShowEmptyFields: boolean; translationBase: string; }
export const PageEntityCustomFields: React.FC<Props> = ({ entity, isShowEmptyFields, translationBase }) => {
  const customFields = get(entity,'fields', []);
  const items = customFields.map((f: any) => ({ question: f.label || f.name, answer: f.value }));
  const allEmpty = items.length > 0 && items.every((i: any) => !i.answer);
  if ((items.length === 0 || allEmpty) && !isShowEmptyFields) return null;
  return (
    <div className="page-entity-custom-fields">
      <ViewTable title={<Translate value={`${translationBase}.custom-questions.title`} />}>
        {items.length === 0 && isShowEmptyFields && (
          <ViewSectionRow title={`${translationBase}.custom-questions.no-questions`} data="" isShowEmptyFields />
        )}
        {items.map((item: any, idx: number) => (
          <ViewSectionRow key={idx} title={item.question} data={item.answer} isShowEmptyFields={isShowEmptyFields} />
        ))}
      </ViewTable>
    </div>
  );
};
export default PageEntityCustomFields;
